import { getUUID } from '@/lib';
import { FC } from 'react';
import styles from './StanLabel.module.css';
import { StanLabelProps } from '../types';

export const StanLabel: FC<StanLabelProps> = ({ label, caption, id = getUUID() }) => {
    return (
        <div className={styles.container}>
            <label id={id} className={styles.label}>
                <span className={styles.labelText}>{label}</span>
                {caption && <span className={styles.caption}>{caption}</span>}
            </label>
        </div>
    );
};
